module.exports = __webpack_public_path__ + "img/symbol_8.6fe89552.png";